var StepTwoBaseView, StepTwoInbentaBaseView, SupportMainContentWrapperView,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportMainContentWrapperView = require('../../main_content_view');

StepTwoBaseView = require('../base_view');

StepTwoInbentaBaseView = (function(superClass) {
  extend(StepTwoInbentaBaseView, superClass);

  function StepTwoInbentaBaseView() {
    this.getHelpContenteErrorCb = bind(this.getHelpContenteErrorCb, this);
    this.getHelpContentSuccessCb = bind(this.getHelpContentSuccessCb, this);
    return StepTwoInbentaBaseView.__super__.constructor.apply(this, arguments);
  }

  StepTwoInbentaBaseView.prototype.initialize = function(options) {
    this.options = options || {};
    StepTwoBaseView.prototype.initialize.apply(this, arguments);
    this.isInbentaContentShown = false;
    this.dropDownCombinationsModel = this.options.dropDownCombinationsModel;
    if (this.dropDownCombinationsModel.has('flexStepThree')) {
      this.dropdownCombinations = this.dropDownCombinationsModel.attributes;
    }
    return this.flexStepThree = {
      allowed: false,
      responseReceived: false,
      dropdownCombinations: this.dropdownCombinations
    };
  };

  StepTwoInbentaBaseView.prototype.resetFlexStepThree = function() {
    this.flexStepThree.allowed = false;
    return this.flexStepThree.responseReceived = false;
  };

  StepTwoInbentaBaseView.prototype.render = function() {
    var mainContentWrappper;
    Groupon.Support.ContentModel.onInitStepTwo();
    this.fetchFlexibleContactChannels();
    this.hideComponents();
    toggleCallUs(Groupon.Support.CURRENTVIEW.id);
    mainContentWrappper = new SupportMainContentWrapperView;
    mainContentWrappper.render((function(_this) {
      return function(contentWrapper) {
        _this.renderProgressBar(contentWrapper);
        _this.renderLegacyOrderBanner(contentWrapper);
        _this.renderOrderInfo(contentWrapper);
        _this.fetchAndRenderCategory(contentWrapper);
        return _this.renderInbentaSearchBox(contentWrapper);
      };
    })(this));
    this.$el.append(mainContentWrappper.el);
    this.renderStepTwoActions();
    return this.renderLiveChat(this.$el);
  };

  StepTwoInbentaBaseView.prototype.isFlexStepThreeAllowed = function() {
    var taglineSelected;
    taglineSelected = _.first(this.getTaglines());
    this.flexStepThree['allowed'] = (typeof experiments !== "undefined" && experiments !== null ? experiments.flexStepThreeForUS : void 0) && _.indexOf(this.dropDownCombinationsModel.get('flexStepThree'), taglineSelected != null ? taglineSelected.key : void 0) !== -1;
    return this.flexStepThree['allowed'];
  };

  StepTwoInbentaBaseView.prototype.getHelpContentSuccessCb = function() {
    return this.helpContentSuccess;
  };

  StepTwoInbentaBaseView.prototype.getHelpContenteErrorCb = function() {
    return this.helpContentError;
  };

  StepTwoInbentaBaseView.prototype.isCategoryAndSubcategorySelected = function() {
    return (Groupon.Support.ContentModel.getCategory() != null) && (Groupon.Support.ContentModel.getSubCategory() != null);
  };

  StepTwoInbentaBaseView.prototype.getHelpContentPaths = function() {
    var url, urls;
    url = window.SUPPORTBASEURL + "/fetch?should_display_cms_content=" + (window.shouldShowFlexibleFormsForUS());
    return urls = [url];
  };

  StepTwoInbentaBaseView.prototype.getTaglines = function() {
    var base;
    base = window.shouldShowFlexibleFormsForUS() ? (this.getCategoryId()) + "," + (this.getSubCategoryId()) + "," + this.tagLine : (this.getCategoryId()) + "," + (this.getSubCategoryId());
    return [
      {
        key: base,
        base: "helpwizard_email_form",
        type: "flexible_step_three"
      }
    ];
  };

  StepTwoInbentaBaseView.prototype.fetchFlexibleContactChannels = function() {
    if (this.shouldFetchFlexibleContactChannels()) {
      this.flexibleContactChannelModel.setFetchContactChannelFromCMS();
      return this.flexibleContactChannelModel.fetch();
    }
  };

  return StepTwoInbentaBaseView;

})(StepTwoBaseView);

module.exports = StepTwoInbentaBaseView;

//# sourceMappingURL=data:application/json;base64,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
